import { render } from "./testimoni.vue?vue&type=template&id=a00ea222"
import script from "./testimoni.vue?vue&type=script&lang=js"
export * from "./testimoni.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__